import type { ImageRequireSource } from 'react-native'

// Keeping the base asset lets each platform select the matching density variant.
export const pinImageSources: Record<'order' | 'venue', ImageRequireSource> = {
    order: require('@/assets/images/map/order-pin.png'),
    venue: require('@/assets/images/map/venue-pin.png'),
}
